import { Box, Typography } from '@mui/material'
import type { ProcurementFilters } from '../ProcurementPage'

interface Props {
  filters: ProcurementFilters
}

export default function ProcurementPurchaseListView({ filters }: Props) {
  return (
    <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', gap: 1 }}>
      <Typography variant="h6" fontWeight={700}>
        Purchase
      </Typography>
      <Typography variant="body2" color="text.secondary">
        This tab will host the Procurement Purchase control list based on Access forms
        {' '}
        <strong>frmProcurementMainSubFormLocalP</strong>
        {' '}
        and
        {' '}
        <strong>frmProcurementQryLocalP</strong>
        , filtered by the shared Delivery Lastest and Is Forced Close header filters.
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Current header filters: startDate={filters.startDate}, endDate={filters.endDate}, isForcedClose=
        {filters.isForcedClose}
        .
      </Typography>
    </Box>
  )
}

